const mesiDaAccumulare = (row, mese) => {
  if (row.sezione === "payroll_bpoint") return [1, 4, 7, 10].includes(Number(mese)) ? 1 : 0;
  if (row.tipologia_fatturazione === "B"
    && ["altri_adempimenti", "forfait_consulenza", "forfait_f24", "import_file"].includes(row.sezione)) {
    return [1, 4, 7, 10].includes(Number(mese)) ? 3 : 0;
  }
  // Queste sezioni sono già generate esclusivamente nel loro mese effettivo.
  if (String(row.prestazione) === "186"
    || ["payroll_iipay", "forfait_f24"].includes(row.sezione)) return 1;

  // I forfait consulenza possono essere annuali come natura della voce, ma
  // confluiscono nella prima fattura utile secondo la periodicità del cliente.
  const periodicita = String(
    row.sezione === "forfait_consulenza"
      ? row.periodicita_cliente_fatturazione
      : row.periodicita_fatturazione
    || "mensile"
  ).toLowerCase();
  switch (periodicita) {
    case "trimestrale": return [1, 4, 7, 10].includes(mese) ? 3 : 0;
    case "semestrale": return [1, 7].includes(mese) ? 6 : 0;
    case "annuale": return mese === 4 ? 12 : 0;
    case "custom": {
      const mesi = [...new Set(String(row.mesi_fatturazione_periodicita || "")
        .split(",").map(Number).filter((value) => value >= 1 && value <= 12))]
        .sort((a, b) => a - b);
      if (!mesi.includes(mese)) return 0;
      if (mesi.length === 1) return 12;
      const index = mesi.indexOf(mese);
      const precedente = index === 0 ? mesi[mesi.length - 1] - 12 : mesi[index - 1];
      return mese - precedente;
    }
    default: return 1;
  }
};

const rigaNellaFattura = (row, mese) => {
  if (row.sezione === "sconto_cliente" || row.origine === "sconto") return Number(row.fatturazione_offset || 0) === 0;
  const mesi = mesiDaAccumulare(row, mese);
  const offset = Number(row.fatturazione_offset || 0);
  const trimestrePrecedenteBpoint = row.tipologia_fatturazione === "B"
    && ["altri_adempimenti", "forfait_consulenza", "forfait_f24", "import_file"].includes(row.sezione);
  return mesi > 0 && (trimestrePrecedenteBpoint ? offset >= 1 && offset <= 3 : offset >= 0 && offset < mesi);
};

// Il CSV AGO arrotonda lo sconto di ogni voce a due decimali.
const importoScontoAgo = (totale, percentuale) => Number(totale) > 0 && Number(percentuale) > 0
  ? Number((Number(totale) * Number(percentuale) / 100).toFixed(2)) : 0;

const normalizzaCodicePrestazione = (value) => String(value || '').trim().replace(/^0+(?=\d)/, '');
const isRigaSezioneTreUnificabile = (row) => row.sezione === 'altri_adempimenti'
  && !['1222', '1236'].includes(normalizzaCodicePrestazione(row.nuovo_codice_ago || row.prestazione));

// Stessi gruppi di Fatturazione: le sezioni diverse dalla 3 e le voci libere
// restano distinte; la percentuale sulle voci accumulate è quella esposta in UI.
const scontiDaFatturare = (lines, mese) => {
  const groups = new Map();
  lines.filter(row => rigaNellaFattura(row, mese)
    && !['esclusa', 'eliminata'].includes(row.stato)
    && row.sezione !== 'sconto_cliente' && row.origine !== 'sconto'
    && Number(row.totale || 0) !== 0).forEach((row, index) => {
    const codice = normalizzaCodicePrestazione(row.nuovo_codice_ago || row.prestazione);
    const key = [row.codice_univoco_azienda, row.sezione, codice,
      isRigaSezioneTreUnificabile(row) ? '' : index].join('|');
    const group = groups.get(key) || { codice: row.codice_univoco_azienda, totale: 0, percentuale: 0 };
    group.totale += Number(row.totale || 0);
    group.percentuale = Math.max(group.percentuale, Number(row.sconto_percentuale_attivo || 0));
    groups.set(key, group);
  });
  const cents = new Map();
  for (const group of groups.values()) {
    const value = Math.round(importoScontoAgo(group.totale, group.percentuale) * 100);
    cents.set(group.codice, (cents.get(group.codice) || 0) + value);
  }
  return new Map([...cents].map(([codice, value]) => [codice, value / 100]));
};

export { mesiDaAccumulare, rigaNellaFattura, importoScontoAgo, normalizzaCodicePrestazione,
  isRigaSezioneTreUnificabile, scontiDaFatturare };
